import { Box, Text, VStack, HStack, Radio, Stack } from "@chakra-ui/react";
import { ReactNode } from "react";

interface AudienceListItemProps {
  title: string;
  description: string;
  icon: ReactNode;
  iconBgColor?: string;
  value: string;
  isSelected: boolean;
  onSelect: (value: string) => void;
  isRecommended?: boolean;
  isDisabled?: boolean;
  showRadio?: boolean;
  showPlus?: boolean;
}

const AudienceListItem = ({
  title,
  description,
  icon,
  iconBgColor = "blue.50",
  value,
  isSelected,
  onSelect,
  isRecommended = false,
  isDisabled = false,
  showRadio = true,
  showPlus = false,
}: AudienceListItemProps) => {
  return (
    <HStack
      w="full"
      p={4}
      border="1px solid"
      borderColor={isSelected ? "blue.300" : "gray.200"}
      borderRadius="md"
      backgroundColor="white"
      cursor={isDisabled ? "not-allowed" : "pointer"}
      _hover={!isDisabled ? { borderColor: "blue.300" } : {}}
      transition="all 0.2s"
      opacity={isDisabled ? 0.5 : 1}
      onClick={!isDisabled ? () => onSelect(value) : undefined}
      spacing={4}
    >
      <Box
        w="12"
        h="12"
        borderRadius="md"
        backgroundColor={iconBgColor}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
      >
        {icon}
      </Box>

      <VStack
        alignItems="flex-start"
        justifyContent="center"
        flex={1}
        spacing={1}
        w="full"
      >
        <HStack w="full" justify="space-between" align="flex-start">
          <VStack align="flex-start" spacing={0}>
            <Text fontWeight="bold" fontSize="md" color="gray.800">
              {title}
            </Text>
            <Text fontSize="sm" color="gray.600" lineHeight="1.4">
              {description}
            </Text>
          </VStack>
          {isRecommended && (
            <Stack my="auto">
              <Text fontSize="xs" color="green.600" fontWeight="600">
                Recommended
              </Text>
            </Stack>
          )}
        </HStack>
      </VStack>

      {showRadio && (
        <Radio
          value={value}
          isChecked={isSelected}
          onChange={() => onSelect(value)}
          isDisabled={isDisabled}
          colorScheme="blue"
          size="lg"
        />
      )}
      {showPlus && (
        <Box
          w="8"
          h="8"
          borderRadius="md"
          backgroundColor="white"
          border="1px solid"
          borderColor="gray.200"
          boxShadow="sm"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text fontSize="xs" color="gray.600" fontWeight="bold">
            +
          </Text>
        </Box>
      )}
    </HStack>
  );
};

export default AudienceListItem;
